import { ReportData } from '../types/reportTypes';

// Parse currency string to number
const parseCurrency = (value: string): number => {
  return parseFloat(value.replace(/[$,]/g, ''));
};

// Parse percentage string to number
const parsePercentage = (value: string): number => {
  return parseFloat(value.replace(/%/g, '')) / 100;
};

// Calculate the sum of an array of numbers
const sum = (numbers: number[]): number => {
  return numbers.reduce((total, num) => total + num, 0);
};

// Calculate the individual job data from the April CSV
const jobData = [
  {
    jobInfo: "E-341: Reynaldo & Juanita Delacruz",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 24416.72,
    grossMarginPct: 0.5285,
    grossProfit: 12904.24,
    salesCommission: 1709.17,
    salesManagerFee: 244.17,
    companyOH: 3784.59,
    netProfit: 7166.31
  },
  {
    jobInfo: "E-337: Colette Moussavi",
    leadSource: "Angi",
    trade: "Attic Insulation",
    contractTotal: 4010.00,
    grossMarginPct: 0.6883,
    grossProfit: 2760.08,
    salesCommission: 401.00,
    salesManagerFee: 40.10,
    companyOH: 621.55,
    netProfit: 1697.43
  },
  {
    jobInfo: "E-351: Mark & Jaime Dega",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 16887.00,
    grossMarginPct: 0.6172,
    grossProfit: 10422.66,
    salesCommission: 1688.70,
    salesManagerFee: 168.87,
    companyOH: 2617.49,
    netProfit: 5947.60
  },
  {
    jobInfo: "E-342: Kendall Thomas",
    leadSource: "Angi",
    trade: "Windows & Doors",
    contractTotal: 9896.00,
    grossMarginPct: 0.5862,
    grossProfit: 5801.04,
    salesCommission: 692.72,
    salesManagerFee: 98.96,
    companyOH: 1533.88,
    netProfit: 3475.48
  },
  {
    jobInfo: "E-323: Harsha & Claire Kodali",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 1721.00,
    grossMarginPct: 0.4997,
    grossProfit: 859.98,
    salesCommission: 68.84,
    salesManagerFee: 17.21,
    companyOH: 266.76,
    netProfit: 507.17
  },
  {
    jobInfo: "E-339: Victor Bengtson",
    leadSource: "Homebuddy",
    trade: "Windows & Doors",
    contractTotal: 5621.00,
    grossMarginPct: 0.4521,
    grossProfit: 2541.25,
    salesCommission: 224.84,
    salesManagerFee: 56.21,
    companyOH: 871.26,
    netProfit: 1388.94
  },
  {
    jobInfo: "E-328: Alex Tarasco",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 10373.75,
    grossMarginPct: 0.5077,
    grossProfit: 5266.75,
    salesCommission: 726.16,
    salesManagerFee: 103.74,
    companyOH: 1607.93,
    netProfit: 2828.92
  },
  {
    jobInfo: "E-319: Garth Superville",
    leadSource: "Thumbtack",
    trade: "Siding",
    contractTotal: 6797.40,
    grossMarginPct: 0.4007,
    grossProfit: 2723.72,
    salesCommission: 271.90,
    salesManagerFee: 67.97,
    companyOH: 1053.60,
    netProfit: 1330.25
  },
  {
    jobInfo: "E-322: Yvonne Jefferson",
    leadSource: "Networx",
    trade: "Windows & Doors",
    contractTotal: 3270.00,
    grossMarginPct: 0.6650,
    grossProfit: 2174.55,
    salesCommission: 327.00,
    salesManagerFee: 32.70,
    companyOH: 506.85,
    netProfit: 1308.00
  },
  {
    jobInfo: "E-321: Zenia Jones",
    leadSource: "Google Organic Search",
    trade: "Siding",
    contractTotal: 17000.00,
    grossMarginPct: 0.4011,
    grossProfit: 6818.70,
    salesCommission: 680.00,
    salesManagerFee: 170.00,
    companyOH: 2635.00,
    netProfit: 3333.70
  },
  {
    jobInfo: "E-299: April & Ben Kasper",
    leadSource: "Referral - Word of mouth",
    trade: "Windows & Doors",
    contractTotal: 12401.77,
    grossMarginPct: 0.5195,
    grossProfit: 6442.72,
    salesCommission: 868.12,
    salesManagerFee: 124.02,
    companyOH: 1922.27,
    netProfit: 3528.31
  },
  {
    jobInfo: "E-324: David & Darnice Jasper",
    leadSource: "Google Organic Search",
    trade: "Siding",
    contractTotal: 36889.95,
    grossMarginPct: 0.6630,
    grossProfit: 24458.04,
    salesCommission: 3689.00,
    salesManagerFee: 368.90,
    companyOH: 5717.94,
    netProfit: 14682.20
  },
  {
    jobInfo: "E-298: Robert & Karen Davenport",
    leadSource: "Networx",
    trade: "Siding",
    contractTotal: 5765.50,
    grossMarginPct: 0.4054,
    grossProfit: 2337.33,
    salesCommission: 230.62,
    salesManagerFee: 57.66,
    companyOH: 893.65,
    netProfit: 1155.40
  },
  {
    jobInfo: "E-326: Maurice Roman",
    leadSource: "Thumbtack",
    trade: "Attic Insulation",
    contractTotal: 2804.34,
    grossMarginPct: 0.4827,
    grossProfit: 1353.65,
    salesCommission: 112.17,
    salesManagerFee: 28.04,
    companyOH: 434.67,
    netProfit: 778.77
  },
  {
    jobInfo: "E-306: Donna Moreland",
    leadSource: "Web to Lead Form",
    trade: "Roofing",
    contractTotal: 8750.00,
    grossMarginPct: 0.4058,
    grossProfit: 3550.75,
    salesCommission: 350.00,
    salesManagerFee: 87.50,
    companyOH: 1356.25,
    netProfit: 1757.00
  },
  {
    jobInfo: "E-300: Steven Penrod",
    leadSource: "Homebuddy",
    trade: "Roofing",
    contractTotal: 28592.45,
    grossMarginPct: 0.5820,
    grossProfit: 16640.81,
    salesCommission: 2001.47,
    salesManagerFee: 285.92,
    companyOH: 4431.83,
    netProfit: 9921.59
  },
  {
    jobInfo: "E-302: Taylor Lange",
    leadSource: "Referral - Word of mouth",
    trade: "Roofing",
    contractTotal: 26256.55,
    grossMarginPct: 0.4500,
    grossProfit: 11815.45,
    salesCommission: 1050.26,
    salesManagerFee: 262.57,
    companyOH: 4069.77,
    netProfit: 6432.85
  },
  {
    jobInfo: "E-296: Adrienne Hurt",
    leadSource: "Google Organic Search",
    trade: "Gutters",
    contractTotal: 2586.00,
    grossMarginPct: 0.6118,
    grossProfit: 1582.11,
    salesCommission: 258.60,
    salesManagerFee: 25.86,
    companyOH: 400.83,
    netProfit: 896.82
  },
  {
    jobInfo: "E-297: Lindsey & Peter Miller",
    leadSource: "Google Organic Search",
    trade: "Gutters",
    contractTotal: 4767.00,
    grossMarginPct: 0.6440,
    grossProfit: 3069.95,
    salesCommission: 476.70,
    salesManagerFee: 47.67,
    companyOH: 738.89,
    netProfit: 1806.69
  },
  {
    jobInfo: "E-309: Kevin Swanson",
    leadSource: "Referral - From past customer",
    trade: "Siding",
    contractTotal: 10765.75,
    grossMarginPct: 0.6119,
    grossProfit: 6587.56,
    salesCommission: 1076.58,
    salesManagerFee: 107.66,
    companyOH: 1668.69,
    netProfit: 3734.63
  },
  {
    jobInfo: "E-291: William Smith",
    leadSource: "Web to Lead Form",
    trade: "Roofing",
    contractTotal: 10078.00,
    grossMarginPct: 0.5690,
    grossProfit: 5734.38,
    salesCommission: 705.46,
    salesManagerFee: 100.78,
    companyOH: 1562.09,
    netProfit: 3366.05
  },
  {
    jobInfo: "E-282: Bradley & Marilyn Foard",
    leadSource: "Web to Lead Form",
    trade: "Roofing",
    contractTotal: 8832.00,
    grossMarginPct: 0.4105,
    grossProfit: 3625.54,
    salesCommission: 353.28,
    salesManagerFee: 88.32,
    companyOH: 1368.96,
    netProfit: 1814.98
  },
  {
    jobInfo: "E-350: Theresa & Mario Almeida",
    leadSource: "Thumbtack",
    trade: "Roofing",
    contractTotal: 7470.00,
    grossMarginPct: 0.4391,
    grossProfit: 3280.08,
    salesCommission: 298.80,
    salesManagerFee: 74.70,
    companyOH: 1157.85,
    netProfit: 1748.73
  },
  {
    jobInfo: "E-331: Vsev & Monika Horodyskyj",
    leadSource: "Referral - From past customer",
    trade: "Roofing",
    contractTotal: 14500.00,
    grossMarginPct: 0.5807,
    grossProfit: 8420.15,
    salesCommission: 1015.00,
    salesManagerFee: 145.00,
    companyOH: 2247.50,
    netProfit: 5012.65
  },
  {
    jobInfo: "E-330: Mark & Lynn Eyre",
    leadSource: "Web to Lead Form",
    trade: "Roofing",
    contractTotal: 12787.98,
    grossMarginPct: 0.5370,
    grossProfit: 6867.15,
    salesCommission: 895.16,
    salesManagerFee: 127.88,
    companyOH: 1982.14,
    netProfit: 3861.97
  },
  {
    jobInfo: "E-333: PAUL SLUBY JR",
    leadSource: "Networx",
    trade: "Roofing",
    contractTotal: 9129.00,
    grossMarginPct: 0.4000,
    grossProfit: 3651.60,
    salesCommission: 365.16,
    salesManagerFee: 91.29,
    companyOH: 1415.00,
    netProfit: 1780.15
  },
  {
    jobInfo: "E-313: Anissa & Maria Hawkins",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 14291.00,
    grossMarginPct: 0.5099,
    grossProfit: 7286.98,
    salesCommission: 1000.37,
    salesManagerFee: 142.91,
    companyOH: 2215.11,
    netProfit: 3928.59
  },
  {
    jobInfo: "E-317: Jeffery & Loretta Johnson",
    leadSource: "Web to Lead Form",
    trade: "Roofing",
    contractTotal: 12065.00,
    grossMarginPct: 0.4690,
    grossProfit: 5658.49,
    salesCommission: 482.60,
    salesManagerFee: 120.65,
    companyOH: 1870.08,
    netProfit: 3185.16
  },
  {
    jobInfo: "E-314: Beth & Bill Sherman",
    leadSource: "Web to Lead Form",
    trade: "Roofing",
    contractTotal: 29040.00,
    grossMarginPct: 0.4212,
    grossProfit: 12231.65,
    salesCommission: 1161.60,
    salesManagerFee: 290.40,
    companyOH: 4501.20,
    netProfit: 6278.45
  },
  {
    jobInfo: "Molly & Frankie Wilkin",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 9872.00,
    grossMarginPct: 0.4000,
    grossProfit: 3948.80,
    salesCommission: 394.88,
    salesManagerFee: 98.72,
    companyOH: 1530.16,
    netProfit: 1925.04
  },
  {
    jobInfo: "Ali Zaghab",
    leadSource: "Networx",
    trade: "Windows & Doors",
    contractTotal: 5029.43,
    grossMarginPct: 0.4000,
    grossProfit: 2011.77,
    salesCommission: 201.18,
    salesManagerFee: 50.29,
    companyOH: 779.56,
    netProfit: 980.74
  },
  {
    jobInfo: "Steven & Rachel (Delbalzo) Heidenberg",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 8220.00,
    grossMarginPct: 0.4000,
    grossProfit: 3288.00,
    salesCommission: 328.80,
    salesManagerFee: 82.20,
    companyOH: 1274.10,
    netProfit: 1602.90
  }
];

// Calculate totals
const totalContractValue = sum(jobData.map(job => job.contractTotal));
const totalGrossProfit = sum(jobData.map(job => job.grossProfit));
const totalSalesCommissions = sum(jobData.map(job => job.salesCommission));
const totalManagerFees = sum(jobData.map(job => job.salesManagerFee));
const totalCompanyOH = sum(jobData.map(job => job.companyOH));

// April 2025 data for the marketing report - based on CSV data
export const aprilData: ReportData = {
  kpis: {
    // Sum of all ad spends from the April CSV
    adSpend: 46788.32, // Should be sum of April adSpend with Angi = 2530.00
    
    // Sum of all contract totals from the April Sales CSV
    totalSales: totalContractValue,
    
    // Sum of all gross profits from the April Sales CSV
    grossProfit: totalGrossProfit,
    
    // Sum of all sales commissions
    salesCommissions: totalSalesCommissions,
    
    // Sum of all manager fees
    managerFees: totalManagerFees,
    
    // Company overhead 
    companyOH: totalCompanyOH,
    
    // Net profit calculation
    netProfit: totalGrossProfit - totalSalesCommissions - totalManagerFees - totalCompanyOH - 46788.32, // Should be recalculated with correct adSpend
    
    // Net profit as percentage of total sales
    netProfitPercent: (totalGrossProfit - totalSalesCommissions - totalManagerFees - totalCompanyOH - 46788.32) / totalContractValue, // Should be recalculated with correct adSpend
    
    // Gross profit as percentage of total sales
    grossProfitPercent: totalGrossProfit / totalContractValue
  },
  
  // Ad spend by lead source from April AdSpend CSV
  adSpendBySource: [
    { source: "Web to Lead Form (Roofing Calculator)", spend: 11441.00 },
    { source: "HomeBuddy", spend: 10089.00 },
    { source: "Thumbtack", spend: 10500.00 },
    { source: "Google Organic", spend: 3500.00 },
    { source: "Yelp", spend: 3000.00 },
    { source: "Angi", spend: 2530.00 },
    { source: "Networx", spend: 2107.00 },
    { source: "Facebook / Meta Ads", spend: 1854.35 },
    { source: "Google AdWords", spend: 924.15 },
    { source: "Google LSA", spend: 542.82 },
    { source: "BBB", spend: 300.00 },
    { source: "Contractor Appointment", spend: 0.00 },
    { source: "Porch", spend: 0.00 },
    { source: "Guild Quality", spend: 0.00 },
    { source: "Lead2Performance", spend: 0.00 },
    { source: "Spring Connect", spend: 0.00 }
  ],
  
  // Sales by lead source - aggregated from April Sales CSV
  salesBySource: [
    { source: "Google Organic Search", totalSales: 96723.70, count: 7, grossProfit: 54906.21 },
    { source: "Web to Lead Form", totalSales: 81552.98, count: 6, grossProfit: 37667.96 },
    { source: "Yelp", totalSales: 48579.72, count: 3, grossProfit: 24140.02 },
    { source: "Homebuddy", totalSales: 34213.45, count: 2, grossProfit: 19182.06 },
    { source: "Referral - Word of mouth", totalSales: 38658.32, count: 2, grossProfit: 18258.17 },
    { source: "Thumbtack", totalSales: 18792.74, count: 4, grossProfit: 8217.43 },
    { source: "Networx", totalSales: 23193.93, count: 4, grossProfit: 10175.25 },
    { source: "Angi", totalSales: 13906.00, count: 2, grossProfit: 8561.12 },
    { source: "Referral - From past customer", totalSales: 25265.75, count: 2, grossProfit: 15007.71 }
  ],
  
  // Sales by trade - aggregated from April Sales CSV
  salesByTrade: [
    { trade: "Windows & Doors", totalSales: 107559.67, count: 11, grossProfit: 55671.61 },
    { trade: "Roofing", totalSales: 182292.98, count: 12, grossProfit: 89263.03 },
    { trade: "Siding", totalSales: 77218.60, count: 5, grossProfit: 25020.35 },
    { trade: "Attic Insulation", totalSales: 6814.34, count: 2, grossProfit: 4113.73 },
    { trade: "Gutters", totalSales: 7353.00, count: 2, grossProfit: 4652.06 }
  ],
  
  // Individual job data from April Sales CSV
  jobData: jobData,
  period: {
    month: 4, // April
    year: 2025
  }
};